/* http://dinbror.dk/blog/blazy/?ref=github */
import Blazy from 'blazy';
new Blazy({
    breakpoints: [
        {width: 575, src: 'data-src-sm'},
        {width: 767, src: 'data-src-md'},
        {width: 991, src: 'data-src-lg'},
        {width: 1199, src: 'data-src-xl'},
    ]
});



// WEBPACK FOOTER //
// ./themes/wild/assets/js/lazyLoad.js